import Vue from 'vue'
import Vuex from 'vuex'
import Login from '@tencent/vft-common/login'
import cookie from '@tencent/vft-common/cookie'
import {
  vipService
} from '@tencent/vft-union-fetch'
import indexService from './pages/index/services/service'
import wujiService from './pages/index/services/wuji'
import moment from 'moment'
import login from '@tencent/vft-common/login';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    payVip: undefined,
    userInfo: undefined,
    eggInfo: null,
    myShareCode: '',
    leaderboardList: [],
    costAllCount: 0,
    giveAllCount: 0,
    lotteryMax: 0,
    now: new Date().getTime(),
    isOfficial: false,
    dialogList: {
      congratulatePop: false,
      strategyPop: false,
      pendDanAward: true
    },
    loginStatus: false,
    eggList: [],
    eggType: { special_id: '' }
  },

  getters: {
    payVip: state => state.payVip,
    userInfo: state => state.userInfo,
    eggInfo: state => state.eggInfo,
    myShareCode: state => state.myShareCode,
    shareConfig: () => {
      let item = window.setting.默认分享
      return {
        imgUrl: item.分享图,
        title: item.分享标题,
        desc: item.分享描述,
        timeLineTitle: item.分享朋友圈标题,
        link: item.分享链接
      }
    },
    pangdanShareConfig: () => {
      let list = window.setting.碰蛋分享
      let item = list[parseInt(Math.random() * list.length)] || list[0]
      return {
        imgUrl: item.分享图,
        title: item.分享标题,
        desc: item.分享描述,
        timeLineTitle: item.分享朋友圈标题,
        link: item.分享链接
      }
    },
    leaderboardList: state => state.leaderboardList,
    costAllCount: state => state.costAllCount,
    giveAllCount: state => state.giveAllCount,
    lotteryMax: state => state.lotteryMax,
    now: state => state.now,
    isOfficial: state => {
      return true
    },
    eggList: state => state.eggList,
    eggType: state => state.eggType,
    egg: state => {
      let list = state.eggList

      if (state.eggInfo) {
        list = list.filter(item => +item.type === state.eggInfo['egg_type'])
      }
      
      if (state.myShareCode) {
        let index = ((state.myShareCode[0]||'d').charCodeAt()) % list.length
        return list[index]
      }

      return list[0] || {
        image: '',
        name: ''
      }
    },
    shareLogo: state => {
      let specialLogo = {
        'DNF':'https://puui.qpic.cn/vupload/0/20190126_1548495099653_hdnfllj3ke.png/0',
        'default':'https://puui.qpic.cn/vupload/0/20190126_1548495099653_svyp9785sc.png/0',
        'qqfeiche':'https://puui.qpic.cn/vupload/0/20190126_1548495099653_mg79kqfdtv.png/0',
        'cijizhanchang':'https://puui.qpic.cn/vupload/0/20190126_1548495099653_vqffe3tqke.png/0',
        'zhihu':'https://puui.qpic.cn/vupload/0/20190126_1548495099654_wnklz6ceweb.png/0',
      }

      let id = state.eggType['special_id']
      if(id && specialLogo[id]){
        return specialLogo[id]
      }else {
        return specialLogo.default
      }
    }
  },

  mutations: {
    saveIsLogin(state, isLogin) {
      state.isLogin = isLogin
    },
    savePayVip(state, payVip) {
      state.payVip = payVip
    },
    saveUserInfo(state, userInfo) {
      if (!userInfo.id) {
        if (userInfo.type === 2) {
          userInfo.id = Login.getUin()
        } else {
          userInfo.id = cookie.get('vuserid')
        }
      }
      state.userInfo = userInfo
    },
    saveEggInfo(state, eggInfo) {
      state.eggInfo = eggInfo
    },
    saveMyShareCode(state, code) {
      state.myShareCode = code
    },
    saveleaderBoardInfo(state, info) {
      state.leaderboardList = info.list || []
    },
    saveNow(state, time) {
      state.now = time || new Date().getTime()
    },

    saveStatisticData(state, info) {
      state.costAllCount = info['cost_all_count'] || 0
      state.giveAllCount = info['give_all_count'] || 0
      state.lotteryMax = info['lottery_max_all'] || 0
    },

    saveEggList(state, list) {
      state.eggList = list
    },

    saveEggType(state, list) {
      state.eggType = list
    },

    saveLoginStatus(state, status) {
      state.loginStatus = status
    },

    openDialog(state, name) {
      state.dialogList[name] = true
    },
    closeDialog(state, name) {
      state.dialogList[name] = false
    }
  },
  actions: {
    async checkLogin({
      commit
    }) {
      let isLogin = await vipService.isLogin()
      commit('saveIsLogin', isLogin)
      return isLogin
    },
    async getUserInfo({
      commit,
      state
    }) {
      let userInfo = await vipService.getMainUserInfo()
      let oldVal = state.userInfo
      let newVal = userInfo
      if (userInfo) {
        if (!oldVal) {
          commit('saveUserInfo', userInfo)
        } else if (oldVal.type !== newVal.type || oldVal.openId !== newVal.openId || oldVal.uin !== newVal.uin) {
          commit('saveUserInfo', userInfo)
        }
      }
    },

    async getPayVip({
      commit
    }) {
      try {
        let payVip = await vipService.getPayVip(true)
        commit('savePayVip', payVip)
      } catch (e) {
        console.error(e)
        login.logout(() => {
          window.location.reload()
        })
      }
    },

    async getEggInfo({ commit, state }) {
      let defaultValue = {
        egg_type: 0,
        egg_count: 0,
        special_id: ''
      }

      if (!state.isLogin) {
        return commit('saveEggInfo', defaultValue)
      }

      try {
        const res = await indexService.getEggInfo()
        if (res.ret === 0) {
          commit('saveEggInfo', res.data)
        } else if (res.ret === -11) {
          return commit('saveLoginStatus', true)
        } else {
          Vue.prototype.alert({
            title: `蛋迷路了，请重试(${res.ret})`,
            confirm: () => {
              window.location.reload()
            }
          })
          return commit('saveEggInfo', defaultValue)
        }
      } catch (err) {
        commit('saveEggInfo', defaultValue)

        Vue.prototype.alert({
          title: '蛋迷路了，请重试',
          confirm: () => {
            window.location.reload()
          }
        })

        throw err
      }
    },

    async getMyShareCode({ commit }) {
      const res = await indexService.getShareCode()
      if (res.ret === 0) {
        commit('saveMyShareCode', res.data['share_code'])
      } else if (res.ret === -11) {
        commit('saveLoginStatus', true)
      }
    },

    async getLeaderboardInfo({ commit }) {
      const res = await indexService.getLeaderboard()
      if (res.ret === 0) {
        commit('saveleaderBoardInfo', res)
        // commit('saveNow', res.timestamp * 1000)
      }
    },

    async getStatisticData({ commit }) {
      const res = await indexService.getStatisticData()

      if (res.ret === 0) {
        commit('saveStatisticData', res)
      }
    },

    async getEggList({ commit, state }) {
      const res = await wujiService.getEggList()
      commit('saveNow', res._time)
      if (res.code === 200) {
        let eggList = res.data || []
        if (state.eggType) {
          eggList = eggList.filter(item => item.special === state.eggType['special_id'])
        }
      
        commit('saveEggList', eggList)
      }
    },

    async getEggType({ commit }) {
      const res = await indexService.getEggType()
      // commit('saveNow', res._time)
      if (res.ret === 0) {
        let list = res.data
      
        commit('saveEggType', list || {
          special_id: ''
        })
      }
    },

    openDialog({ commit }, name) {
      commit('openDialog', name)
    },
    closeDialog({ commit }, name) {
      commit('closeDialog', name)
    }
  }
})
